/* unplugin-vue-components disabled */import { render } from "./Nft.vue?vue&type=template&id=5f80d037&scoped=true"
import script from "./Nft.vue?vue&type=script&lang=js"
export * from "./Nft.vue?vue&type=script&lang=js"

import "./Nft.vue?vue&type=style&index=0&id=5f80d037&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f80d037"]])

export default __exports__